import * as types from './types';

const INITIAL_STATE = {};

function _setStationDetails(state, action) {
    const {
        meta: stationId,
        payload: data,
    } = action;

    if (!stationId || !data) {
        return state;
    }

    return {
        ...state,
        [stationId]: data,
    };
}

const handlers = {
    [types.SET_STATION_DETAILS]: _setStationDetails,
};

function reducer(state = INITIAL_STATE, action) {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];
        return handler(state, action);
    }

    return state;
}

export default reducer;
